import styled from 'styled-components'
import { ForgotPasswordFormUnstyled } from './unstyled'

export const ForgotPasswordForm = styled(ForgotPasswordFormUnstyled)`
  position: relative;
  width: 100%;
  height: 100%;

  form {
    position: absolute;
    width: 100%;
    max-width: 360px;
    left: 0;
    right: 0;
    top: 50%;
    margin: auto;
    transform: translateY(-50%);
  }

  form .under-form .link-wrapper:nth-child(1) {
    display: block;
    margin: 20px 0 0 0;
  }

  input[type='submit'] {
    margin: 38px 0 0 0;
  }

  .form-inputs .text-input-wrapper {
    margin: 40px 0 0 0;
  }

  h1 {
    font-size: 28px;
    margin: 0;
  }

  p {
    margin: 35px 0 0 0;
    color: ${props => props.theme.colors.regentGray};
  }
`



// WEBPACK FOOTER //
// ./src/Containers/Form/ForgotPassword/index.js